export default "__VITE_ASSET__B0Zait91__"